<template>
  <div class="order-return-superuser">
    <div>
      <div class="input-column">
        <validation-observer
          ref="observerAccount"
          tag="form">
          <div class="input-column__container">
            <div class="handle-shipping-myself-container">
              <oie-base-checkbox v-model="superuserOptions.handleShippingMyself" is-for="order-return-create-rma" :text="t('handleShippingMyselfLabel')"></oie-base-checkbox><div v-tooltip.top="t('handleShippingMyselfTooltip')" class="indicate-tooltip"></div>
            </div>
            <oie-base-dropdown
              v-show="!superuserOptions.handleShippingMyself && !selectedArticlesHaveTransportLabels"
              v-model="superuserOptions.shippingKey"
              css-classes="handle-shipping-myself-dropdown"
              :initial-text="t('dropdownInitalText')"
              :options="shippingAgentServices"
              :is-large="false"
              :use-full-width="true"
              :use-thin-border="true"
              :label-text="t('rmaShippingAgent')"></oie-base-dropdown>
            <oie-message-box v-if="selectedArticlesHaveTransportLabels && !superuserOptions.handleShippingMyself" class="message-box message-box--orange message-box--compact order-return-message message-box--green">
              {{ t('selectedArticlesHaveTransportLabelsNote') }}
            </oie-message-box>
          </div>
        </validation-observer>
      </div>
    </div>

    <div class="order-return-superuser__actions-container">
      <div class="order-return-superuser__actions-right">
        <oie-base-button
          v-if="!issueKey || createRmaAlongWithIssue"
          v-epi-edit="'createOrderReturnButtonLabel'"
          :disabled="!superuserOptions.handleShippingMyself && superuserOptions.shippingAgentService === null"
          :text="t('rmaCreateIssueAndRma')"
          css-classes="button--with-border button--green order-return-superuser__action-button"
          :use-full-width="true"
          @click="createOrderReturnInParentAndRma"></oie-base-button>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    issueKey: {
      type: String,
      default: null
    },
    orderNumber: {
      type: String,
      default: null
    },
    createRmaAlongWithIssue: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    shippingSettings: null,
    shippingAgents: [],
    selectedArticlesHaveTransportLabels: false,
    isOpen: true,
    superuserOptions: {
      handleShippingMyself: false,
      createOrderReturnAndRma: false,
      shippingCost: 0,
      createRma: true,
      shippingKey: null,
      shippingAgent: null,
      shippingAgentService: null,
      documentToCustomer: 'DEFAULT',
      createConsignmentNote: true,
      rma: null,
      consignmentNoteUrl: null,
      shippingQuoteRequested: null
    }
  }),
  computed: {
    shippingAgentServices() {
      if (!this.shippingSettings) { return [] }

      let services = []

      for (let i = 0; i < this.shippingSettings.length; i++) {
        const key = this.shippingSettings[i].key
        const customerShippingName = this.shippingSettings[i].customerShippingName
        const priceAmount = this.shippingSettings[i].priceAmount
        const priceCurrency = this.shippingSettings[i].priceCurrency
        const enabledForCustomers = this.shippingSettings[i].enabledForCustomers

        if (enabledForCustomers) {
          if (key === 'QUOTE') {
            services.push({ text: customerShippingName, value: key })
          } else {
            services.push({ text: customerShippingName + ' - ' + priceAmount + ' ' + priceCurrency, value: key })
          }
        }
      }

      return services
    }
  },
  watch: {
    superuserOptions: {
      handler: function (newSuperuserOptions, oldSuperuserOptions) {
        if (!this.superuserOptions.handleShippingMyself && (this.superuserOptions.shippingAgent === 'QUOTE' || this.superuserOptions.shippingAgent === 'Offert')) {
          this.superuserOptions.shippingQuoteRequested = 'Kunden har BEGÄRT OFFERT för returfrakt'
        } else {
          this.superuserOptions.shippingQuoteRequested = 'Kunden har inte begärt offert för returfrakt'
        }

        this.publish('order-return-superuser-updated', newSuperuserOptions)
      },
      deep: true
    }
  },
  mounted() {
    this.$watch(
      'superuserOptions.shippingKey',
      (newVal, oldVal) => {
        if (newVal) {
          let shippingSetting = this.shippingSettings.filter(a => a.key === newVal)[0]
          this.superuserOptions.shippingAgent = shippingSetting.shippingAgent
          this.superuserOptions.shippingAgentService = shippingSetting.shippingAgentService
          this.superuserOptions.shippingCost = shippingSetting.priceAmount

          this.superuserOptions.createConsignmentNote = true
        }
      })

    this.$watch(
      'superuserOptions.handleShippingMyself',
      (newVal, oldVal) => {
        if (newVal) {
          this.superuserOptions.createConsignmentNote = false
          this.superuserOptions.shippingCost = 0
        }
      })

    this.subscribe('order-return-rows-selection-updated', selectedRows => {
      this.selectedArticlesHaveTransportLabels = false

      if (selectedRows.some(item => item.transportLabels && item.transportLabels.length > 0)) {
        this.selectedArticlesHaveTransportLabels = true
      }
    })

    httpService.get(`order-return/shipping-settings?orderNumber=${this.orderNumber}&forCustomers=true`).then((response) => {
      this.shippingSettings = response.data
      this.superuserOptions.shippingKey = this.shippingSettings.filter(item => item.enabledForCustomers)[0].key
    })

    this.subscribe('order-return-created', (orderReturn) => {
      this.issueKey = orderReturn.issueKey

      if (this.superuserOptions.createOrderReturnAndRma) {
        this.superuserOptions.createOrderReturnAndRma = false

        if (!this.superuserOptions.handleShippingMyself && this.superuserOptions.shippingKey !== 'QUOTE') {
          this.createRma()
        }
      }
    })
  },
  methods: {
    createRma() {
      const rmaJson = {
        issueKey: this.issueKey,
        orderNumber: this.orderNumber,
        shippingCost: this.superuserOptions.shippingCost,
        shippingAgent: this.superuserOptions.shippingAgent,
        shippingAgentService: this.superuserOptions.shippingAgentService,
        documentToCustomer: this.superuserOptions.documentToCustomer,
        createConsignmentNote: this.superuserOptions.createConsignmentNote
      }

      httpService.post(`order-return/rma`, rmaJson).then((response) => {
        this.superuserOptions.rma = response.data.rma
        this.superuserOptions.consignmentNoteUrl = response.data.consignmentNoteUrl
        this.publish('order-return-superuser-rma-created', this.superuserOptions)
      })
        .catch(error => {
          this.publish('order-return-general-error', error.response)
        })
    },
    createOrderReturnInParentAndRma() {
      this.$parent.$refs.observer.validate().then((valid) => {
        if (valid) {
          this.superuserOptions.createOrderReturnAndRma = true
        }
      })
    }
  }
}
</script>

<style lang="scss">
    .order-return-superuser__actions-right {
      width: 100%;
      margin-top: 1rem;

      @include media(medium) {
        max-width: 24rem;
        width: 100%;
        margin-left: auto;
      }
    }

    .rma-confirmation {
        margin-bottom: 2rem;
    }

    .handle-shipping-myself-container {
        display: flex;
    }

    .handle-shipping-myself-container > .indicate-tooltip {
        margin-left: 1rem;
    }

    .handle-shipping-myself-container > .indicate-tooltip::after {
        margin-left: -0.39rem !important;
    }

</style>
